import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import dayjs from 'dayjs';
import type { ChargeMonthlyOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  CHARGE_MONTHLY_DEFAULT_TAB,
  CHARGE_MONTHLY_SHOW_TABS,
} from '../constants';
import { ChargeMonthlyShowHeader } from './ChargeMonthlyShowHeader';
import { ChargeMonthlyGeneralTab } from './ChargeMonthlyGeneralTab';
import { ChargeDailyTab } from './ChargeDailyTab';

export const ChargeMonthlyShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<ChargeMonthlyOut>({
    resource: 'settlement.charges_monthly',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle(
    'settlement.charges_monthly',
    record && dayjs(record.bucket).format('YYYY-MM')
  );

  const [activeTab, onTabChange] = useShowTab(
    CHARGE_MONTHLY_SHOW_TABS,
    CHARGE_MONTHLY_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <ChargeMonthlyShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <ChargeMonthlyGeneralTab record={record} />
            )}
            {activeTab === 'daily' && <ChargeDailyTab record={record} />}
          </div>
        </>
      )}
    </Show>
  );
};
